import { LineEmail } from '@qr-front/icons/line-email'
import { LineLinkAlt01 } from '@qr-front/icons/line-link-alt-01'
import { LinePhone } from '@qr-front/icons/line-phone'
import { LineUser } from '@qr-front/icons/line-user'
import { Separator } from '@qr-front/ui/components/Separator'
import {
	contactInfoEmailListAtom,
	contactInfoPhoneListAtom,
	contactInfoWebsiteAtom,
	toLabeledEntries,
} from 'features/generator/contentFormSections/CommonSections/ContactSection'
import { contactInfoFullNameAtom } from 'features/generator/contentFormSections/ContactInfoForm/ContactInfoForm'
import { useAtomValue } from 'jotai'
import { useTranslations } from 'next-intl'
import { Fragment } from 'react'
import { addMissingUrlProtocol } from 'utils/urlUtils'

import { ContactItem } from './ContactItem'
import { SectionListContainer } from './SecionListContainer'

export const ContactSection = () => {
	const t = useTranslations()

	const fullName = useAtomValue(contactInfoFullNameAtom)

	const fullNameItem = fullName ? (
		<ContactItem
			key="contact"
			contactItem={{
				label: t(
					'generator__qr_content_screen__business_info_type__sections__contact__full_name',
				),
				Icon: LineUser,
				value: fullName,
				ValueWrapper: ({ value, className }) => (
					<p className={className}>{value}</p>
				),
			}}
		/>
	) : null

	const phoneList = toLabeledEntries(
		useAtomValue(contactInfoPhoneListAtom),
		t,
	)

	const phoneItem = phoneList.length ? (
		<ContactItem
			key="contact"
			contactItem={{
				Icon: LinePhone,
				value: phoneList,
				ValueWrapper: ({ value, className }) => (
					<a
						href={`tel:${value}`}
						title={value}
						className={className}
					>
						{value}
					</a>
				),
			}}
		/>
	) : null

	const emailList = toLabeledEntries(
		useAtomValue(contactInfoEmailListAtom),
		t,
	)

	const emailItem = emailList.length ? (
		<ContactItem
			key="email"
			contactItem={{
				Icon: LineEmail,
				value: emailList,
				ValueWrapper: ({ value, className }) => (
					<a
						href={`mailto:${value}`}
						title={value}
						className={className}
					>
						{value}
					</a>
				),
			}}
		/>
	) : null

	const websiteUrl = useAtomValue(contactInfoWebsiteAtom)

	const websiteItem = websiteUrl?.length ? (
		<ContactItem
			key="website"
			contactItem={{
				label: t(
					'generator__qr_content_screen__vcard_type__sections__contact__website',
				),
				Icon: LineLinkAlt01,
				value: websiteUrl,
				ValueWrapper: ({ value, className }) => (
					<a
						href={addMissingUrlProtocol(value)}
						className={className}
					>
						{value}
					</a>
				),
			}}
		/>
	) : null

	const itemList = [fullNameItem, phoneItem, emailItem, websiteItem].filter(
		(item) => item !== null,
	)

	return (
		<SectionListContainer>
			{itemList.map((item, index) =>
				itemList.length > 1 && index < itemList.length - 1 ? (
					<Fragment key={index}>
						{item}
						<Separator collapse />
					</Fragment>
				) : (
					item
				),
			)}
		</SectionListContainer>
	)
}
